import React from 'react';
import { Building2 } from 'lucide-react';

export function TeamMembers() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <Building2 className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Władze fundacji
        </h2>
      </div>
    
      <div className="space-y-6">
        {/* Organ reprezentacji */}
        <div>
          <h3 className="heading-4 mb-4">
            Organ reprezentacji
          </h3>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h4 className="label-large mb-2">
              Zarząd Fundacji
            </h4>
            <p className="body-medium">
              Sposób reprezentacji: każdy członek zarządu samodzielnie
            </p>
          </div>
        </div>

        {/* Zarząd Fundacji */}
        <div>
          <h3 className="heading-4 mb-4">
            Zarząd Fundacji
          </h3>
          <div className="space-y-4">
            <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
              <h4 className="label-large mb-1">
                Magda Katarzyna Pasterz
              </h4>
              <p className="body-medium">
                Prezes
              </p>
            </div>
            <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
              <h4 className="label-large mb-1">
                Sylwia Karolina Sokulska
              </h4>
              <p className="body-medium">
                Członek Zarządu
              </p>
            </div>
          </div>
        </div>

        {/* Rada Fundacji */}
        <div>
          <h3 className="heading-4 mb-4">
            Rada Fundacji
          </h3>
          <div className="space-y-4">
            <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
              <h4 className="label-large mb-1">
                Beata Zowczak
              </h4>
            </div>
            <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
              <h4 className="label-large mb-1">
                Agata Marta Szulc
              </h4>
            </div>
            <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
              <h4 className="label-large mb-1">
                Łukasz Zbigniew Muniowski
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}